'use client'

import MainSlider, {
  type MainSliderAccent,
  type MainSliderNews,
  type MainSliderSize,
} from '@/components/MainSlider'

interface MainSliderClientProps {
  news: MainSliderNews[]
  size?: MainSliderSize
  accent?: MainSliderAccent
  accentColor?: string | null
  className?: string
  lcpPriority?: boolean
  imageSizes?: string
}

/** Swiper client boundary — görseller sunucuda çözümlenir, SSR korunur */
export default function MainSliderClient({
  news,
  size = 'main',
  accent = 'red',
  accentColor,
  className = '',
  lcpPriority = false,
  imageSizes,
}: MainSliderClientProps) {
  return (
    <MainSlider
      news={news}
      size={size}
      accent={accent}
      accentColor={accentColor}
      pagination="bars"
      lcpPriority={lcpPriority}
      imageSizes={imageSizes}
      className={className}
    />
  )
}
